import axiosInstance from "./axiosInstance";

const extractError = (err) => {
    const data = err?.response?.data;
    if (data?.errors) {
        const msgs = Object.values(data.errors).flat();
        if (msgs.length) return msgs.join(", ");
    }
    return data?.message || data?.error || err.message || "Request failed";
};

const unwrap = (res) => {
    const body = res.data;
    if (body?.success === false) {
        throw new Error(body.message || body.error || "Request failed");
    }
    return body;
};

const listRows = (body) => {
    if (Array.isArray(body?.data)) return body.data;
    if (Array.isArray(body?.data?.data)) return body.data.data;
    return [];
};

export const isDomainVerified = (domain) => {
    const status = String(
        domain?.ses_verification_status ?? domain?.status ?? ""
    ).toUpperCase();
    return status === "SUCCESS" || status === "AUTHENTICATED";
};

// --- Email domains (superadmin or EMAIL-ADMIN) ---

export const listEmailDomains = async (params = {}) => {
    try {
        const res = await axiosInstance.get("/email-domains", {
            params: { per_page: 100, ...params },
            headers: { Accept: "application/json" },
        });
        const body = unwrap(res);
        return listRows(body);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const createEmailDomain = async (payload) => {
    try {
        const res = await axiosInstance.post("/email-domains", payload, {
            headers: { Accept: "application/json", "Content-Type": "application/json" },
        });
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const getEmailDomainDnsRecords = async (domainId) => {
    try {
        const res = await axiosInstance.get(`/email-domains/${domainId}/ses-dns-records`, {
            headers: { Accept: "application/json" },
        });
        return unwrap(res).data ?? unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const verifyEmailDomain = async (domainId) => {
    try {
        const res = await axiosInstance.post(
            `/email-domains/${domainId}/ses-verify`,
            {},
            { headers: { Accept: "application/json", "Content-Type": "application/json" } }
        );
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const deleteEmailDomain = async (domainId) => {
    try {
        const res = await axiosInstance.delete(`/email-domains/${domainId}`, {
            headers: { Accept: "application/json" },
        });
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

// --- Sender emails ---

export const listSenderEmails = async (params = {}) => {
    try {
        const res = await axiosInstance.get("/email-business/sender-emails", {
            params,
            headers: { Accept: "application/json" },
        });
        const body = unwrap(res);
        return listRows(body);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const createSenderEmail = async (payload) => {
    try {
        const res = await axiosInstance.post("/email-business/sender-emails", payload, {
            headers: { Accept: "application/json", "Content-Type": "application/json" },
        });
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const updateSenderEmail = async (id, payload) => {
    try {
        const res = await axiosInstance.put(`/email-business/sender-emails/${id}`, payload, {
            headers: { Accept: "application/json", "Content-Type": "application/json" },
        });
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};

export const deleteSenderEmail = async (id) => {
    try {
        const res = await axiosInstance.delete(`/email-business/sender-emails/${id}`, {
            headers: { Accept: "application/json" },
        });
        return unwrap(res);
    } catch (err) {
        throw new Error(extractError(err));
    }
};
